import * as moment from 'moment';

import { DateTimeConverter } from 'src/app/core/services/mapper/converters';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Animateur } from '../../commission/models/animateur.model';
import { TourneeEchantillon } from './tournee-echantillon.models';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Tournee {
    static jsonMap = {
        id: { key: 'id', optional: true },
        dateDebut: { key: 'dateDebut', converter: new DateTimeConverter(), optional: true },
        dateFin: { key: 'dateFin', converter: new DateTimeConverter(), optional: true },
        numero: { key: 'numero', optional: true, default: '' },
        echantillons: { key: 'echantillons', converter: new (ArrayClassConverterFactory.build(TourneeEchantillon))(), optional: true, default: () => [] },
        technicien: { key: 'idTechnicien', converter: new (DataIdConverterFactory.build(Animateur, 'techniciens'))(), optional: true },
        terminee: { key: 'terminee', optional: true }
    };

    id: number;
    dateDebut: moment.Moment;
    dateFin: moment.Moment;
    numero: string;
    echantillons: TourneeEchantillon[];
    technicien: Animateur;
    terminee: boolean;
}
